/** Fallback editor config.
 *
 * The live values come from GET /v2/engagements/email-templates/config, so the
 * UI stays in sync with what the backend actually interpolates and which
 * trigger anchors are really implemented. These constants are only used if that
 * request fails, so the editor degrades to something usable instead of blank.
 */
export const FALLBACK_TOKENS = [
  { token: "first_name", label: "First name" },
  { token: "last_name", label: "Last name" },
  { token: "recipient_name", label: "Full name" },
  { token: "survey_link", label: "Assessment link" },
  { token: "company_name", label: "Company name" },
];

export const FALLBACK_ANCHORS = [
  { key: "INVITATION_SENT", label: "Invitation sent", implemented: true },
];
